module.exports = __webpack_public_path__ + "static/media/Calendar.a0295bc5.png";